<template>
  <el-container class="basic-layout">
    <el-header style="height: 64px">
      <Header />
    </el-header>
    <el-container>
      <el-aside width="200px">
        <AsideMenu />
      </el-aside>
      <el-main>
        <el-card>
          <router-view />
        </el-card>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from './Header';
import AsideMenu from './AsideMenu';

export default {
  components: {
    Header,
    AsideMenu
  }
};
</script>

<style lang="less" scoped>
.basic-layout {
  width: 100%;
  height: 100%;
}

.el-header {
  padding: 0;
}

.el-container {
  .el-aside {
    background-color: #272b38;
  }

  .el-main {
    height: calc(100vh - 64px);
    // width: 100%;
    background-color: #f3f6fe;
    padding: 16px;

    .el-card {
      border: none;
      min-height: 100%;
      word-wrap: break-word;
      word-break: break-all;
      overflow: hidden;
      position: relative;
      /deep/ .el-card__body {
        padding: 0;
      }
    }
  }
}
</style>
